import $ from 'jquery'

const DATA_KEY = 'opp.disabled'
const Selector = {
  DISABLED: '[disabled], .disabled'
}

function setDisabled(el, bool, options) {
  const $el = $(el)
  const data = $el.data(DATA_KEY)

  // require force option to override sticky state
  if (data && data.sticky) {
    if (!options) {
      return
    }

    if (!options.force) {
      return
    }
  }

  // Set sticky state when sticky option is set
  if (options && options.sticky) {
    $el.data(DATA_KEY, { sticky: true })
  } else {
    $el.data(DATA_KEY, { sticky: false })
  }

  // Update DOM
  if (bool) {
    $el.addClass('disabled')
  } else {
    $el.removeClass('disabled')
  }

  $el.prop('disabled', bool)
  $el.attr('aria-disabled', bool)
}

$.fn.disabled = function (val, options) {
  // Setter
  if (typeof val !== 'undefined') {
    return this.each(function () {
      setDisabled(this, Boolean(val), options)
    })
  }

  // Getter
  return this.is(Selector.DISABLED)
}
